module.exports = __webpack_public_path__ + "img/adm.b2ee01d7.png";